import axios, { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { DampReportApplicationFormData } from 'types/forms/dampReportApplicationTypes';
import { ICreateSubmissionRequest } from 'types/services/baseServiceTypes';
import { createServiceInstance } from '../baseService';
import {
  IGetArnReferenceDataRequest,
  IGetArnReferenceDataResponse,
  ISubmissionResponse,

} from './dampReportServiceTypes';

let cancel;

export interface IDampReportService {
  getArnReferenceData: (request?: IGetArnReferenceDataRequest) => Promise<AxiosResponse<IGetArnReferenceDataResponse>>;
  submitCreateDampReportApplication: (request: ICreateSubmissionRequest<DampReportApplicationFormData>) => Promise<AxiosResponse<ISubmissionResponse>>;
}

/**
 * DAMP Report service hook
 *
 * @description Gives access to all services relating to ARN
 */
const useDampReportService = (): IDampReportService => {
  const token = useSelector(() => useSelector((state: any) => state.B2CSettings.items.accesstokenForms));
  const webappurlFormsApi = useSelector(() => useSelector((state: any) => state.B2CSettings.items.webappurlFormsApi));
  const getInstance = () => createServiceInstance(`${webappurlFormsApi}/api/myCASA/Forms/drone`, token);
  const getDampInstance = () => createServiceInstance(`${webappurlFormsApi}/api/myCASA/Forms/damp`, token);


  const getArnReferenceData = (request?: IGetArnReferenceDataRequest): Promise<AxiosResponse<IGetArnReferenceDataResponse>> => {
    const axiosInstance = getInstance();

    return axiosInstance.post<IGetArnReferenceDataResponse>('/GetReferenceDataTypes/v1', request);
  };

  const submitCreateDampReportApplication = (request?: ICreateSubmissionRequest<DampReportApplicationFormData>): Promise<AxiosResponse<ISubmissionResponse>> => {
    const axiosInstance = getDampInstance();

    return axiosInstance.post<ISubmissionResponse>('/createDampSubmission/v1', request);
  };
  return {
    getArnReferenceData: getArnReferenceData,
    submitCreateDampReportApplication: submitCreateDampReportApplication
  };
};

export default useDampReportService;